import { useRef, useState } from "react";

import { ActionsMenu } from "./ActionsMenu";
import { EntityContext } from "../../types/commonTypes";

interface Action {
  text: string | React.ReactNode;
  icon?: React.ReactNode;
}

interface DottedTriggerMenuProps {
  entityContext: EntityContext;
  actions?: Action[];
  onMenuOpenChange?: (isOpen: boolean) => void;
}

export const DottedTriggerMenu = ({
  entityContext,
  actions = [],
  onMenuOpenChange,
}: DottedTriggerMenuProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const triggerRef = useRef<HTMLDivElement>(null);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    const newIsOpen = !isOpen;
    setIsOpen(newIsOpen);
    onMenuOpenChange?.(newIsOpen);
  };

  const handleClose = () => {
    setIsOpen(false);
    onMenuOpenChange?.(false);
  };

  return (
    <div className="relative">
      <div
        ref={triggerRef}
        className="flex justify-center items-center w-[27px] min-w-[27px] h-[27px] min-h-[27px] border border-black rounded-full transition-all duration-100 hover:cursor-pointer"
        onClick={handleClick}
      >
        <i className="mt-0.5 bi bi-three-dots font-black" />
      </div>
      <ActionsMenu
        entityContext={entityContext}
        actions={actions}
        isOpen={isOpen}
        onClose={handleClose}
        triggerRef={triggerRef}
      />
    </div>
  );
};
